interface SeparatorProps {
  edge?: 'start' | 'end';
}

export function Separator({ edge }: SeparatorProps) {
  return (
    <div
      data-print-edge={edge}
      data-print-separator="true"
      style={{ borderTop: '1px dashed #111' }}
    />
  );
}
